// Module
var code = "<input class=\"form-control-range is-valid numeric range optional my-1\" type=\"range\" step=\"10000\" value=\"10\" max=\"1000000\" id=\"prospect_search_budget_bar\"> ";
// Exports
module.exports = code;